import type { FunctionComponent } from "react";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";

import { StyledLogoLink, StyledPostMagazineLogoText } from "./styles";

export type PostMagazineLogoTextLinkProps = HeaderFeatureCommonProps;

export const PostMagazineLogoTextLink: FunctionComponent<PostMagazineLogoTextLinkProps> = ({
  ...props
}) => (
  <StyledLogoLink pathname="/postmag" {...getResponsiveProps(props)}>
    <StyledPostMagazineLogoText />
  </StyledLogoLink>
);

PostMagazineLogoTextLink.displayName = "PostMagazineLogoTextLink";
